// @ts-nocheck
import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LoadingWidget from "../widgets/loader";
import RulesDataContext from "contexts/RulesContext";
import { useSetRecoilState } from "recoil";
import { errorState } from "recoil/error/atom";
import LocaleContext from "../contexts/LocaleContext";
import i18n from 'i18next';
import config from "config";
import styles from "../containers/App/App.module.scss";
import FooterLogo from "assets/images/logo.png";

const ErrorBoundary = lazy(() => import("../ErrorBoundary"));
const IFrameSearchAndMatchList = lazy(() => import("containers/SearchAndMatch/IFrameSearchAndMatchList"));

const IframeRoutes = ({ rulesDetails }: { rulesDetails?: unknown }) => {
  const popError = useSetRecoilState(errorState);
  const [locale, setLocale] = useState<string>(i18n.language);

  const renderRoutesChildren = () => (
  <RulesDataContext.Provider value={rulesDetails}>
    <Switch>
      <Route
        exact
        path="/aitssearch"
        render={() => (
          <div id="app">
            <div className={styles.app}>
              <div className={styles.appPage}>
                <div className="container">
                  <IFrameSearchAndMatchList />
                </div>
              </div>
            </div>
          </div>
          )}
      />
      <Route
        path="/aitssearch/:id"
        render={() => (
          <div id="app">
            <div className={styles.app}>
              <div className={styles.appPage}>
                  <IFrameSearchAndMatchList />
              </div>
            </div>
          </div>
        )}
      />
     </Switch>
  </RulesDataContext.Provider>
  );

  return (
    <Router>
      <LocaleContext.Provider value={{ locale, setLocale }}>
        <Suspense
          fallback={
            <div style={{ textAlign: "center", padding: "5rem" }}>
              <LoadingWidget color="grey" />
            </div>
          }>
          <ErrorBoundary popError={popError}>
            {renderRoutesChildren()}
            <footer className={styles.appFooter + " container"}>
              <a
                href={
                  window.location.hostname === "employer.qjumpers.co" ? "https://www.qjumpers.co.nz" : config.app.website
                }
                target="_blank"
                className={styles.appFooterLogo} rel="noreferrer">
                <img src={FooterLogo} alt={config.app.title} />
              </a>
            </footer>
          </ErrorBoundary>
        </Suspense>
      </LocaleContext.Provider>
    </Router>
  );
};

export default IframeRoutes;
